module.exports = __webpack_public_path__ + "static/media/Coins_Tex@3x.283242a6.png";